module.exports = "/images/Intro_Flyer.png?c8ee6cc435e6fbfdac5a4f45f1674ce3";